import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX_SIGNALS } from '../../../../../Blocks/SyntheticIndicators/constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class SignalDetail extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        detail: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        toggledDetails: PropTypes.object,
        toggleSignalDetail: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    handleToggleSignalDetail = () => {
        const { module, block, customData, type, mainId, toggleSignalDetail } = this.props

        const signalOpen = _.get(customData, `toggledDetails.${type}`, false)
        const newCustomData = {
            ...customData,
            toggledDetails: {
                ...customData.toggledDetails,
                [type]: !signalOpen,
            },
        }

        toggleSignalDetail(module, mainId, block, newCustomData)
    }

    render() {
        const { detail, toggledDetails, type } = this.props

        return (
            <div className={'signal-detail'}>
                <div
                    onClick={this.handleToggleSignalDetail}
                    className={cx('detail-title', !_.get(toggledDetails, `${type}`, false) ? 'collapse' : 'expand')}
                >
                    <FormattedMessage id={`${LOCALE_PREFIX_SIGNALS}.syntheticIndicators.detailText`} />
                </div>
                {_.get(toggledDetails, `${type}`, false) && (
                    <div className={'detail-content'}>
                        {detail}
                        {type === 'D009' && (
                            <span>
                                &nbsp;
                                <FormattedMessage id={`${LOCALE_PREFIX_SIGNALS}.temporaryProtectionMoreInformation`} />
                                &nbsp;
                                <a
                                    href={'https://www.slov-lex.sk/pravne-predpisy/SK/ZZ/2020/92/'}
                                    target={'_blank'}
                                    rel={'noopener noreferrer'}
                                >
                                    {'https://www.slov-lex.sk/pravne-predpisy/SK/ZZ/2020/92/'}
                                </a>
                            </span>
                        )}
                    </div>
                )}
            </div>
        )
    }
}
